module.exports = __webpack_public_path__ + "img/4506344_m.a71d24fe.jpg";